module.exports = require('./dist');